import {
  Box,
  Card,
  CardContent,
  Checkbox,
  Grid,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import { Edit } from '@mui/icons-material';
import { IconPrimaryButton } from '../../../components/atoms/Button';
import { capitalizeWords } from '../../../utils/helper';
import { AddEditTechnicianModal } from '../../../components/ui/add/technicianModal';
import {
  ITechnician,
  ProfessionalSkill,
} from '../../../utils/entities/interface';

interface PropsProffesionalCard {
  position: string;
  experience: string;
  technicianId?: string;
  ProfessionalSkills?: ProfessionalSkill[];
  technician: ITechnician | null;
  onRefresh: () => void;
}
export const ProfessionalDetailsCard = ({
  position,
  experience,
  technicianId,
  ProfessionalSkills,
  technician,
  onRefresh,
}: PropsProffesionalCard) => {
  const [isEditModal, setIsEditModal] = useState(false);

  console.log('ProfessionalSkills', ProfessionalSkills);
  const handleEditModalClose = () => {
    setIsEditModal(false);
  };

  return (
    <>
      <Card
        sx={{
          flex: 1,
          backgroundColor: 'Stroke',
          color: 'white',
          // p: 1,
          borderRadius: 2,
          border: '1px solid #444',
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingLeft: 1,
              marginBottom: 1,
            }}
          >
            <Typography variant="h6" gutterBottom>
              Professional Detail
            </Typography>
            <Box>
              <IconPrimaryButton
                title="Edit"
                icon={<Edit />}
                onClick={() => setIsEditModal(true)}
                size="small"
              />
            </Box>
          </Box>

          <Box sx={{ paddingLeft: 1 }}>
            <Grid container spacing={2} mb={3}>
              {/* Position of Professional */}
              <Grid item xs={4}>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#8A8D91',
                  }}
                >
                  Position
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#FFFFFF',
                  }}
                >
                  {capitalizeWords(position) || 'N/A'}
                </Typography>
              </Grid>

              {/* Experience */}
              <Grid item xs={4}>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#8A8D91',
                  }}
                >
                  Experience
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#FFFFFF',
                  }}
                >
                  {capitalizeWords(experience) || 'N/A'}
                </Typography>
              </Grid>
            </Grid>
            <ACTypeMatrix
              isReadOnly
              skills={
                Array.isArray(ProfessionalSkills) ? ProfessionalSkills : []
              }
            />
          </Box>
        </CardContent>
      </Card>

      {isEditModal && (
        <AddEditTechnicianModal
          open={isEditModal}
          onClose={handleEditModalClose}
          onSaved={onRefresh}
          technicianId={technicianId}
          technician={technician}
          action={'EDPRO'}
        />
      )}
    </>
  );
};

const acCols = ['S', 'R', 'I'] as const;

const ACTypeMatrix = ({
  skills,
  isReadOnly = true,
}: {
  skills: ProfessionalSkill[];
  isReadOnly?: boolean;
}) => {
  return (
    <Box>
      {/* Header Row */}
      <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <Grid item xs={4}>
          <Typography variant="body1" color="white">
            {'AC Type'}
          </Typography>
        </Grid>
        {acCols.map((col) => (
          <Grid item xs={1} key={col} sx={{ display: 'flex' }}>
            <Box
              sx={{
                backgroundColor: '#1C1C1C',
                borderRadius: '4px',
                width: 20,
                height: 20,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="caption" color="white" fontWeight={600}>
                {col}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Matrix Rows */}
      {skills.map((row, index) => (
        <Grid
          container
          spacing={1}
          alignItems="center"
          key={index}
          sx={{ mb: 1 }}
        >
          <Grid item xs={4}>
            <Typography variant="body1" color="white">
              {row.acType}
            </Typography>
          </Grid>
          {acCols.map((col) => {
            // Determine correct bool property for this checkbox
            let checked = false;
            if (col === 'S') checked = row.service;
            else if (col === 'R') checked = row.repair;
            else if (col === 'I') checked = row.install;

            return (
              <Grid item xs={1} key={col} sx={{ display: 'flex' }}>
                <Checkbox
                  checked={checked}
                  disabled={isReadOnly}
                  size="small"
                  sx={{
                    padding: 0,
                    color: '#999',
                    '&.Mui-checked': {
                      color: 'white',
                    },
                    '&.Mui-disabled': {
                      color: '#666',
                    },
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      ))}
    </Box>
  );
};
